import React, { useCallback } from 'react'
import { WrapContactUsFab, ContactUsFab } from './Style'
import { SvgIcon, Tooltip } from '@mui/material';
import { createTicketHooks } from '.';
import { TooltipSystem } from 'components/Form';
import { videoURL } from 'keys/general';
import { InstallButton } from 'pages/Auth';
import { ReactComponent as MessageIcon } from 'assets/icons/Message.svg';

const ContactUsFabComponent = () => {
    const setAlert = createTicketHooks.useAlert()

    const getUserExistCookie = useCallback((name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }, [])

    const goContactUs = useCallback(() => {
        setAlert(true)
    }, [])

    const openTooltip = !getUserExistCookie('user_exist');

    const openTutorial = useCallback(() => {
        window.open(videoURL)
    }, [])

    return (
        <WrapContactUsFab>
            <InstallButton />
            <TooltipSystem
                title={
                    <div>
                        <b>
                            לא מצליחים להרשם?
                            או לא מצליחים להתחבר?
                        </b>
                        <div>
                            <div>{"ניתן לפנות אלינו על ידי הכפתור למטה, "}</div>
                            <div>{"נשמח לעזור."}</div>
                            <div>{" לסרטון המסביר על המערכת GoRead לחצו"}
                                <u className='system-link link' onClick={openTutorial}>{" כאן"}</u>
                                {"."}
                            </div>
                        </div>
                    </div>
                }
                open={openTooltip} />
            {openTooltip ?
                <ContactUsFab variant='contained' color="dark" onClick={goContactUs}>
                    <SvgIcon fontSize="large" component={MessageIcon} inheritViewBox />
                </ContactUsFab> :
                <Tooltip title={openTooltip || "צרכים עזרה? פנו אלינו"} placement='top'>
                    <ContactUsFab variant='contained' color="dark" onClick={goContactUs}>
                        <SvgIcon fontSize="large" component={MessageIcon} inheritViewBox />
                    </ContactUsFab>
                </Tooltip>
            }
        </WrapContactUsFab>
    )
}

export default ContactUsFabComponent